<template lang="pug">
    re-toast-alert(v-bind="parentOptions")
        template(v-slot:default="{alert}")
            include ./confirm-content.pug
</template>

<script>
import ConfirmMixin from '../mixins/confirm'
import ReToastAlert from 'utils/vue/components/elements/re-toast-alert'
import ReButton from 'utils/vue/components/basic/buttons/re-button'

export default {
    name: 'cart-rules-confirm-bar',

    components: {
        ReToastAlert,
        ReButton,
    },

    mixins: [
        ConfirmMixin
    ],

    data: () => ({
        defaultParentOptions: {
            type: 'info',
            toast: false
        }
    })
}
</script>
